<button mat-icon-button [matTooltip]="buttonLabel" [attr.aria-label]="buttonLabel" (click)="open()" #notificationButton>
    <mat-icon [matBadge]="unreadCount || null" matBadgeColor="warn" matBadgeSize="small" [matBadgeHidden]="!unreadCount" aria-hidden="false">notifications</mat-icon>
</button>

<ng-template #notificationOverlay>
    <div class="notifications-container" role="dialog" aria-label="Notifications">
        <div class="header">
            <h2>Notifications</h2>
            <button mat-icon-button (click)="close()" aria-label="Close notifications" matTooltip="Close">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        @if (groups.length === 0) {
            <p class="empty">You're all caught up. There are no notifications.</p>
        }@else {
            @for (group of groups; track group.type) {
                <h3>{{group.name}}</h3>
                @for (notification of group.notifications; track notification._key) {
                    <div class="notification" [class.unread]="!notification.read">
                        <div class="meta">
                            <span>{{notification.organisationName}}</span>
                            <span>{{notification.created | date:'mediumDate'}}</span>
                        </div>
                        <p class="text">{{notification.text}}</p>
                        @if (notification.notes) {
                            <p class="notes">"{{notification.notes}}"</p>
                        }
                        <div class="actions">
                            @if (getAction(notification); as action) {
                                <button mat-flat-button color="accent" (click)="select(notification)">{{action}}</button>
                            }@else if (getActionNote(notification); as note) {
                                <span class="note">{{note}}</span>
                            }
                            <span class="spacer"></span>
                            <span class="expiry">Expires {{notification.expiry | date:'mediumDate'}}</span>
                            <button mat-icon-button (click)="deleteNotification(notification)" [disabled]="deleting.has(notification._key)"
                                aria-label="Delete notification" matTooltip="Delete">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                }
            }
        }
    </div>
</ng-template>
